<div id="add-manager-state-of-car" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase uk-margin-bottom">
                    Ajouter un <br>état gestionnaire
                </h2>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Titre</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="stateOfCar.location" (ngModelChange)="validator()" placeholder="Porte du conducteur"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Commentaire</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="stateOfCar.description" (ngModelChange)="validator()" placeholder="RAS"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin" style="margin-bottom: inherit;">
                        <label class="label">Photo (Avant)</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger bold" (click)="modifyPhoto(1)" type="button">
                                <span *ngIf="photos.front === null">Ajouter une photo</span>
                                <span *ngIf="photos.front !== null">{{ photos.front.name }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="uk-margin" style="margin-bottom: inherit;">
                        <label class="label">Photo (Arrière)</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger bold" (click)="modifyPhoto(2)" type="button">
                                <span *ngIf="photos.back === null">Ajouter une photo</span>
                                <span *ngIf="photos.back !== null">{{ photos.back.name }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="uk-margin" style="margin-bottom: inherit;">
                        <label class="label">Photo (Aile gauche)</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger bold" (click)="modifyPhoto(3)" type="button">
                                <span *ngIf="photos.left === null">Ajouter une photo</span>
                                <span *ngIf="photos.left !== null">{{ photos.left.name }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="uk-margin" style="margin-bottom: inherit;">
                        <label class="label">Photo (Aile droite)</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger bold" (click)="modifyPhoto(4)" type="button">
                                <span *ngIf="photos.right === null">Ajouter une photo</span>
                                <span *ngIf="photos.right !== null">{{ photos.right.name }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [disabled]="validated === false" (click)="submit()" class="button bold uk-margin-small-left" type="button">
                    <span *ngIf="loading === false">Ajouter</span>
                    <div *ngIf="loading === true" uk-spinner></div>
                </button>
            </p>
        </div>
    </div>
</div>